import Common from './common';
import util from './utils/util';
import logger from './utils/logger';
import { LEGACY_QUERY_PARAMS, GLOBAL_QUERY_PARAMS, COOKIE_DURATION } from './constans';
import buildWPcpx from './utils/buildWPcpx';

class Tracker {
    constructor(name) {
        const matchingParams = { ...LEGACY_QUERY_PARAMS, ...GLOBAL_QUERY_PARAMS };
        const params = {
            ...util.getQueryParams(document.referrer),
            ...util.getQueryParams(window.location.search)
        };
        this.common = Common;
        this.name = name;
        this.queue = [];
        this.key = null;
        this.module = { events: {} };
        this.modules = [];

        this.common.setMatchedParamsAsCookie(params, matchingParams, COOKIE_DURATION);
        this.common.processSourceClid(params[GLOBAL_QUERY_PARAMS.source_clid]);
        this.debug = this.common.getDebugInfo.call(this, params);

        this.common.trackSession.call(this);
    }

    registerModule(moduleObject) {
        this.modules.push(moduleObject);
    }

    validateContent(params) {
        for (const item in params) {
            if (this.module.content && this.module.content.hasOwnProperty(item)) {
                if (
                    params[item] === null ||
                    params[item] === undefined ||
                    this.module.content[item].type.name !== params[item].constructor.name
                ) {
                    logger.warn(
                        `'${item}' must be of type '${this.module.content[item].type.name}'`
                    );
                    return false;
                }
            }
        }
        return true;
    }

    send(eventName, isCustomEvent, content) {
        logger.debug('Sending', [eventName, isCustomEvent, content], this);

        const cookies = this.common.getCookies.call(this);
        const baseData = this.common.getBaseData.call(this);
        const contentData = this.common.contentMapper.call(this, content);
        const optData = this.common.contentMapper.call(this, this.opt);
        const utmData = this.common.contentMapper.call(this, util.parseUtm());
        const sourceData = this.common.contentMapper.call(this, cookies.global);
        const sessionData = this.common.getAllSessionData.call(this, cookies.session);

        const eventData = {
            e: eventName,
            ...(isCustomEvent && { custom: 1 })
        };

        if (cookies.domodi.id) {
            eventData.dtid = cookies.domodi.id;
        }

        if (cookies.allani.id) {
            eventData.atid = cookies.allani.id;
        }

        if (cookies.wpcpx) {
            eventData.cpx = cookies.wpcpx;
        }

        if (cookies.wph_aduid) {
            eventData.wph_aduid = cookies.wph_aduid;
        }

        const data = {
            ...baseData,
            ...eventData,
            ...contentData,
            ...optData,
            ...utmData,
            ...sourceData,
            ...sessionData
        };

        this.validateContent(content);

        this.queue.push(data);

        if (typeof this.module.events[eventName] === 'function') {
            this.module.events[eventName].call(this, data, cookies);
        } else {
            this.common.createPixel.call(this, data);
        }
    }

    push(action, ...params) {
        logger.debug('Push', [action, ...params], this);

        if (typeof action === 'string' && this.actions.hasOwnProperty(action)) {
            this.actions[action].apply(this, [...params]);
        } else {
            logger.warn(`You are sending a non-standard action ${action}.`);
        }
    }

    actions = {
        init(id, opt = {}) {
            logger.debug('Init', [id, opt], this);

            this.key = id;
            const utm = util.parseUtm();
            opt = { ...opt, ...utm };
            if (opt && typeof opt === 'object' && opt.constructor === Object) {
                const overAll = opt.overAll;
                this.blockLegacyRequest = opt.blr;
                this.blockTransactionSignature = opt.bts;

                delete opt.overAll;
                delete opt.blr;
                delete opt.bts;

                if (overAll) {
                    this.opt = opt;
                } else {
                    const eventName = { e: 'init' };
                    const baseData = this.common.getBaseData.call(this);
                    const optData = this.common.contentMapper.call(this, opt);
                    const cookies = this.common.getCookies.call(this);
                    const sessionData = this.common.getAllSessionData.call(this, cookies.session);
                    const debuggingData = this.common.getDebuggingData.call(this);

                    const transactionData = this.common.contentMapper.call(this, {
                        source_tid: cookies.global.source_tid
                    });
                    if (cookies.domodi.id) transactionData.dtid = cookies.domodi.id;
                    if (cookies.allani.id) transactionData.atid = cookies.allani.id;
                    if (cookies.global.source_clid)
                        transactionData.wph_clid = cookies.global.source_clid;
                    if (cookies.wpcpx) transactionData.wpcpx = cookies.wpcpx;
                    if (cookies.wph_aduid) transactionData.wph_aduid = cookies.wph_aduid;

                    this.common.createPixel.call(this, {
                        ...eventName,
                        ...baseData,
                        ...optData,
                        ...sessionData,
                        ...transactionData,
                        ...debuggingData
                    });
                }
            }

            this.modules.forEach(mod => {
                this.module = { ...this.module, ...mod };
            });

            if (this.newUser) {
                this.actions.track.call(this, 'UserCreated');
                this.newUser = 0;
            }

            window.isTest ? window.setTracker(this) : '';
        },

        track(eventName, ...params) {
            logger.debug('Track', [eventName, ...params], this);

            if (typeof eventName === 'string' && this.module.events.hasOwnProperty(eventName)) {
                this.send.apply(this, [eventName, false, ...params]);
            } else {
                logger.warn(`You are sending a non-standard event '${eventName}'.`);
            }
        },

        trackCustom(eventName, ...params) {
            logger.debug('Track custom', [eventName, ...params], this);

            const eventNameType = typeof eventName;

            if (eventNameType === 'string') {
                this.send.apply(this, [eventName, true, ...params]);
            } else {
                logger.warn(
                    `The event name must be of type - string, but you provide a type - ${eventNameType}`
                );
            }
        },

        consent(eventName) {
            logger.debug('Consent', eventName, this);

            if (eventName === 'grant') {
                buildWPcpx(true);
            } else if (eventName === 'revoke') {
                buildWPcpx(false);
            } else {
                logger.warn(`You are sending a non-standard event '${eventName}'.`);
            }
        }
    };
}

export default Tracker;
